<template>
  <v-container>
    <v-sheet>
      <v-img src="/safesytelogo-tagline.png" width="60%" class="mx-auto"></v-img>
    </v-sheet>

    <v-row>
      <v-col cols="10" offset="1" class="font-weight-bold">
        SafeSyte is een data gedreven en op maat ingerichte webapplicatie voor het continu verbeteren van veiligheid in de bouw. SafeSyte is onafhankelijk en toepasbaar voor zowel kleine als grote bedrijven of projecten.
        <br />
        <br />De SafeSyte webapplicatie:
        <ul>
          <li>geeft inzicht in relevante feiten</li>
          <li>helpt steeds beter te begrijpen wat veiligheid bepaalt</li>
          <li>stimuleert om te leren van elkaar</li>
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="5" offset="1">
        <b>We brengen alle relevante data samen op één plaats</b>
        <br />Start direct met het benutten van data die al wordt verzameld. Krijg inzicht in meer factoren door de combinatie van gegevensbronnen. Denk bijvoorbeeld aan app meldingen, inspectieresultaten, RI&amp;E’s, weergegevens, urenregistraties en ongevallenregistraties.
        Het koppelen van verschillende gegevensbronnen is flexibel en schaalbaar en met aandacht voor IT-security.
      </v-col>
      <v-col cols="5" offset="1">
        <b>We bieden structuur en inzicht op maat</b>
        <br />We presenteren de resultaten van de data-analyses begrijpelijk op verschillende dashboards met als doel om aandacht en inzet vast te houden en gerichte acties te stimuleren. Doordat de dashboards op maat zijn gemaakt is de informatie gericht en kan het gebruik goed ingepast worden in bestaande overlegstructuren.
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="5" offset="1">
        <b>We maken slimme data-analyses toepasbaar</b>
        <br />We voeren automatische data-analyses uit om overzichten te maken van de actuele stand van zaken en om factoren te bepalen die veiligheid en onveiligheid beïnvloeden. Afhankelijk van de wens en de kwantiteit&amp;kwaliteit van de data kunnen verschillende analysemethoden gebruikt worden, van eenvoudig tot de toepassing van machine learning voor het ontdekken van complexere patronen en onderlinge interacties met meerdere factoren.
      </v-col>
      <v-col cols="5" offset="1">
        <b>We maken het mogelijk om ervaringen binnen de bouw te delen</b>
        <br />Deel veiligheidsinzichten om zelf van te leren en om anderen te helpen. Betekenisvolle vergelijking is mogelijk met het SafeSyte datamodel dat generiek is, maar ook maatwerk levert. Vergelijk prestaties en invloedfactoren of maak gebruik van de bouwbrede ongevallendatabase. De vergelijking is vrijwillig en anoniem.
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="10" offset="1">
        De afgelopen jaren is veel aandacht besteed aan de veiligheidscultuur in de bouw ( houding en gedrag). De wil om de bouw veiliger te maken wordt steeds breder gedragen. De aanpak van SafeSyte is erop gericht om die wil zo effectief en slim mogelijk in te zetten.
        <br />
        <br />Meer weten? Neem <router-link to="/contact">contact</router-link> op voor meer informatie of maak een afspraak voor een vrijblijvend gesprek.
        <br />
        <br />
        <v-btn to="/contact" outlined color="primary">Contact</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>